import { useDemoSession } from '../auth/DemoSessionProvider';
import { WORKSPACE_IDS } from '../auth/workspaces';
import { CustodianShell } from './CustodianShell';
import { InvestorShell } from './InvestorShell';
import { OriginatorShell } from './OriginatorShell';
import { ProviderShell } from './ProviderShell';

export function AppLayout() {
  const { session } = useDemoSession();
  const tenantKey = session?.tenantId || session?.workspaceId;

  if (session?.workspaceId === WORKSPACE_IDS.PROVIDER) {
    return <ProviderShell key={tenantKey} />;
  }

  if (session?.workspaceId === WORKSPACE_IDS.CUSTODIAN) {
    return <CustodianShell key={tenantKey} />;
  }

  if (session?.workspaceId === WORKSPACE_IDS.INVESTOR) {
    return <InvestorShell key={tenantKey} />;
  }

  return <OriginatorShell key={tenantKey} />;
}
